$( document ).ready(function() {
  callouts = $(".product-brand-callout")
  callouts.each((i, callout) => {
    console.log("---------------")
    extraMargin = 0
    productJump = parseInt($(callout).attr("line-card"))
    nextProductItem = $(callout).nextAll()[productJump - 1]
    if (!nextProductItem) { //if theres is no product at the line card index, we are at the bottom of the page, so use the card before and add some extra bottom margin
      nextProductItem = $(callout).nextAll()[productJump - 2];
      extraMargin += 30;
    }

    nextCaptionHeight = $(nextProductItem).find(".caption").height() + extraMargin
    mBottom = $(nextProductItem).find(".caption").find("p.price").css("marginBottom")
    nextCaptionHeight += parseInt(mBottom.replace('px', ''))
    // console.log("after",nextCaptionHeight)
    $(callout).find(".caption").css('min-height', nextCaptionHeight + 5);
    //console.log("set to", nextCaptionHeight)
  })
});
